module.exports = __webpack_public_path__ + "img/fastmind.5c4d80a7.svg";